import React from 'react';
import s from './Brands.module.scss';
import { useNavigate } from 'react-router-dom';

interface BrandCardProps {
  logo: string;
  name: string;
  id: number;
}

const BrandCard: React.FC<BrandCardProps> = ({ logo, name, id }) => {
  const navigate = useNavigate();

  return (
    <div className={s.card} onClick={() => navigate(`/brand-items/${id}`)}>
      <div className={s.card_image}>
        <img src={logo} alt={name} />
      </div>
      <div className={s.card_info}>
        <div className={s.card_name}>{name}</div>
      </div>
    </div>
  );
};

export default BrandCard; 